/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RequestLogDtoV2 {
  id?: number;
  requestId?: string;
  method?: string;
  path?: string;
  statusCode?: number | null;
  startedAt?: string;
  durationMs?: number | null;
  userId?: string | null;
  userEmail?: string | null;
  customerEmail?: string | null;
  paymentLinkId?: string | null;
  transactionId?: number | null;
  establishmentId?: number | null;
  posId?: string | null;
  clientId?: string | null;
  hasErrors?: boolean;
  logEntriesCount?: number;
}
